import { useThemeContext } from "./ThemeContext";

const useTheme = () => {
    return useThemeContext();
};

export default useTheme;

